export enum GetEndPoints {
    Roles = '/roles',
    UserId = '/users/{user-id}',
    Users = '/users',
    SavedFilters = '/users/me/saved-filters',
    UserSettings = '/users/me/settings',
    UserProfileId = '/users/{user-id}/profile',
    Download = '/agreements/{agreement-id}/download',
    ListTypeItem = '/agreements/listitems/{type}',
    Dashboard = '/dashboard',
    Measurements = '/measurements',
    MeasurementsComparison = '/measurements/comparison',
    MeasurementsComparisonGrouped = '/measurements/comparison/grouped/{group-by}',
    MeasurementStatisticalDistribution = '/measurements/statistical-distribution',
    MeasurementSignalQualityPrediction = '/measurements/signal-quality-prediction',
    MeasurementFinalResult = '/measurements/{measurement-id}/final',
    Locations = '/locations',
    LocationId = '/locations/{location-id}',
    Regions = '/devices/regions',
    Devices = '/devices',
    Tenants = '/tenants',
    TenantUsers = '/tenants/{tenant-id}/users',
    AddableTenantUsers = '/tenants/{tenant-id}/addable-users',
    MeasurementExportFile = '/measurements/{measurement-id}/export/{file-type}',
    MeasurementsBulkExportJob = '/measurements/export/jobs/{job-id}',
    Device = '/devices/{device-id}',
    DeviceLogFile = '/devices/{device-id}/logfiles/{log-file-id}',
    FirmwareVersions = '/devices/firmware',
    FirmwareVersion = '/devices/firmware/{version-id}',
    FirmwareFiles = '/devices/firmware/{version-id}/files',
    FirmwareFileDownload = '/devices/firmware/files/{file-id}'
}

export enum PostEndPoints {
    Login = '/auth/login',
    Logout = '/auth/logout',
    RefershToken = '/auth/refresh-token',
    User = '/users',
    SavedFilter = '/users/me/saved-filters',
    Upload = '/measurements/upload',
    ListTypeItem = '/agreements/listitems/{type}',
    SendPasswordResetCode = '/users/sendpasswordresetcode',
    ResetPassword = '/users/resetpassword',
    ChangeRepresentation = '/auth/change-representation',
    Location = '/locations',
    Tenant = '/tenants',
    UserToTenant = '/tenants/{tenant-id}/users',
    AddUserToTenantByEmail = '/tenants/users/by-email',
    MeasurementsExportFile = '/measurements/export',
    MeasurementsBulkExport = '/measurements/export/bulk',
    MeasurementsBulkDelete = '/measurements/bulk-delete',
    CheckFirmwareVersion = '/devices/versions',
    VerifyFirmwareUpgrade = '/devices/verify-upgrade',
    NotifyFirmwareUpload = '/devices/notify-upload',
    Firmware = '/devices/firmware'
}

export enum PutEndPoints {
    UserSettings = '/users/me/settings',
    User = '/users/{user-id}',
    Location = '/locations/{location-id}',
    Tenant = '/tenants/{tenant-id}',
    MarkerAnnotation = '/measurements/{measurement-id}/markers/{marker-number}',
    MeasurementAnnotation = '/measurements/{measurement-id}/annotation',
    MeasurementsLocation = '/measurements/location',
    Firmware = '/devices/firmware/{version-id}'
}

export enum DeleteEndPoints {
    User = '/users/{user-id}',
    Location = '/locations/{location-id}',
    Measurement = '/measurements/{measurement-id}',
    UserFromTenant = '/tenants/{tenant-id}/users/{user-id}',
    SavedFilter = '/users/me/saved-filters/{saved-filter-id}',
    Tenant = '/tenants/{tenant-id}',
    DeviceCalibration = '/devices/{device-id}/calibration',
    Firmware = '/devices/firmware/{version-id}'
}
